<div [class.two-column-tool-tip]="_showInfo">
    <mat-form-field appearance="fill" [class.small]="_short" [class.mat-form-field-invalid]="true">
        <mat-label>{{ _labelData.label }}</mat-label>
        <input matInput type="text" [name]="_name" (blur)="onBlur()" [required]="_required" [disabled]="_disabled || _readOnly" #inputControl="ngModel"  [errorStateMatcher]="_matcher" (ngModelChange)="valueUpdated($event)" [type]="_type" [(ngModel)]="_value">
        @if (_showValidationError) {
           <mat-error>{{_labelData.validationErrorText}}</mat-error>
        }
    </mat-form-field>
    @if (_showInfo) {
        <mat-icon color="primary" [matTooltip]="_toolTip"  #tooltip="matTooltip"  (click)="tooltip.toggle()">info</mat-icon>
    }
</div>